var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/types.ts
var QRCodeModulePreset = /* @__PURE__ */ ((QRCodeModulePreset2) => {
  QRCodeModulePreset2["SQUARE"] = "SQUARE";
  QRCodeModulePreset2["DIAMOND"] = "DIAMOND";
  QRCodeModulePreset2["CIRCLE"] = "CIRCLE";
  return QRCodeModulePreset2;
})(QRCodeModulePreset || {});

// src/components/QRCode.tsx
import React3, { useMemo } from "react";

// src/util/eye.ts
var EYE_DIMENSIONS = {
  outer: 7,
  middle: 5,
  inner: 3,
  gap: 1
};
function isEye(row, column, sideLength) {
  const end = sideLength - EYE_DIMENSIONS.outer;
  if (row < EYE_DIMENSIONS.outer) {
    return column < EYE_DIMENSIONS.outer || column >= end;
  }
  if (row >= end) {
    return column < EYE_DIMENSIONS.outer;
  }
  return false;
}

// src/util/path.ts
var moduleToD = (x, y, size, preset = "DIAMOND" /* DIAMOND */) => {
  if (preset === "SQUARE" /* SQUARE */) {
    return square(x, y, size);
  }
  switch (preset) {
    case "DIAMOND" /* DIAMOND */: {
      return diamond(...scale(x, y, size, 0.98));
    }
    case "CIRCLE" /* CIRCLE */: {
      return circle(...scale(x, y, size, 0.95));
    }
    default: {
      return "";
    }
  }
};
var scale = (x, y, size, coefficient) => {
  const actualSize = Math.floor(size * coefficient);
  const sizeDelta = (size - actualSize) / 2;
  const actualX = x + sizeDelta;
  const actualY = y + sizeDelta;
  return [actualX, actualY, actualSize];
};
var circle = (x, y, diameter) => {
  const radius = diameter / 2;
  return `M${x},${y}m0,${radius}a${radius},${radius} 0 1,1 ${diameter},0a${radius},${radius} 0 1,1 ${-diameter},0`;
};
var diamond = (x, y, size) => {
  const half = size / 2;
  return `M${x} ${y + half}l${half} ${half}l${half} ${-half}l${-half} ${-half}`;
};
var square = (x, y, size) => `M${x} ${y} h ${size} v ${size} h ${-size}`;

// src/util/qrcode.ts
import QRCode from "qrcode";
function createQRCode(value, { errorCorrectionLevel, version }) {
  const code = QRCode.create(value, { errorCorrectionLevel, version });
  const data = Array.from(code.modules.data);
  const sideLength = squareLength(data);
  return { sideLength, modules: toModules(data) };
}
function squareLength(data) {
  const sideLength = Math.sqrt(data.length);
  if (!Number.isInteger(sideLength)) {
    throw new Error(`Invalid module data: sqrt(${data.length}) is not an integer`);
  }
  return sideLength;
}
function toModules(array) {
  const sideLength = squareLength(array);
  const modules = [];
  let currentRow = 0;
  for (let i = 0; i < array.length; i++) {
    currentRow = Math.floor(i / sideLength);
    const value = array[i];
    const currentColumn = i % sideLength;
    if (value && !isEye(currentRow, currentColumn, sideLength)) {
      modules.push({
        x: currentColumn,
        y: currentRow
      });
    }
  }
  return modules;
}

// src/components/Eye.tsx
import React from "react";
var Eye = ({
  moduleSize,
  x,
  y,
  components: { Path }
}) => {
  const { outer, inner, gap, middle } = EYE_DIMENSIONS;
  const px = (value) => value * moduleSize;
  return /* @__PURE__ */ React.createElement(Path, {
    strokeWidth: moduleSize,
    fillRule: "evenodd",
    d: square(x, y, px(outer)) + square(x + px(gap), y + px(gap), px(middle)) + square(x + px(gap * 2), y + px(gap * 2), px(inner))
  });
};

// src/components/Logo.tsx
import React2 from "react";
var Logo = ({
  source,
  size,
  quietZone,
  qrcodeSize,
  backgroundColor,
  components: { Image, ClipPath, Defs, Circle }
}) => {
  const actualSize = size - 2 * quietZone;
  const center = qrcodeSize / 2;
  const x = center - actualSize / 2;
  const href = Image === "image" ? source : { uri: source };
  return /* @__PURE__ */ React2.createElement(React2.Fragment, null, /* @__PURE__ */ React2.createElement(Circle, {
    cx: center,
    cy: center,
    r: size / 2,
    fill: backgroundColor
  }), /* @__PURE__ */ React2.createElement(Defs, null, /* @__PURE__ */ React2.createElement(ClipPath, {
    id: "logoclip"
  }, /* @__PURE__ */ React2.createElement(Circle, {
    cx: center,
    cy: center,
    r: actualSize / 2
  }))), /* @__PURE__ */ React2.createElement(Image, {
    x,
    y: x,
    href,
    width: size,
    height: size,
    preserveAspectRatio: "xMidYMid slice",
    clipPath: "url(#logoclip)"
  }));
};

// src/components/QRCode.tsx
var QRCode2 = (_a) => {
  var _b = _a, {
    value,
    backgroundColor,
    size,
    linearGradient,
    errorCorrectionLevel = "high",
    components,
    components: { Rect, Svg, Defs, LinearGradient, Path, Stop, G },
    version,
    quietZone = 4,
    logo,
    modulePreset
  } = _b, restOfProps = __objRest(_b, [
    "value",
    "backgroundColor",
    "size",
    "linearGradient",
    "errorCorrectionLevel",
    "components",
    "components",
    "version",
    "quietZone",
    "logo",
    "modulePreset"
  ]);
  var _a2, _b2, _c, _d;
  const { sideLength, modules } = useMemo(() => createQRCode(value, {
    errorCorrectionLevel,
    version: version === "auto" ? void 0 : version
  }), [value, errorCorrectionLevel, version]);
  const actualSize = size - 2 * quietZone;
  const moduleSize = actualSize / sideLength;
  const start = quietZone;
  const end = size - quietZone;
  const eyeBoundary = end - moduleSize * EYE_DIMENSIONS.outer;
  return /* @__PURE__ */ React3.createElement(Svg, __spreadValues({
    viewBox: `0 0 ${size} ${size}`,
    xmlns: "http://www.w3.org/2000/svg"
  }, restOfProps), linearGradient && /* @__PURE__ */ React3.createElement(Defs, null, /* @__PURE__ */ React3.createElement(LinearGradient, {
    id: "gradient",
    x1: (_a2 = linearGradient.x1) != null ? _a2 : 0,
    x2: (_b2 = linearGradient.x2) != null ? _b2 : size,
    y1: (_c = linearGradient.y1) != null ? _c : 0,
    y2: (_d = linearGradient.y2) != null ? _d : size,
    gradientUnits: "userSpaceOnUse"
  }, linearGradient.stops.map(({ offset, color }, index) => /* @__PURE__ */ React3.createElement(Stop, {
    key: index,
    offset: offset != null ? offset : index,
    stopOpacity: "1",
    stopColor: color
  })))), /* @__PURE__ */ React3.createElement(Rect, {
    x: 0,
    y: 0,
    width: size,
    height: size,
    fill: backgroundColor
  }), /* @__PURE__ */ React3.createElement(G, {
    fill: linearGradient ? "url(#gradient)" : void 0
  }, /* @__PURE__ */ React3.createElement(Eye, {
    x: start,
    y: start,
    moduleSize,
    components
  }), /* @__PURE__ */ React3.createElement(Eye, {
    x: eyeBoundary,
    y: start,
    moduleSize,
    components
  }), /* @__PURE__ */ React3.createElement(Eye, {
    x: start,
    y: eyeBoundary,
    moduleSize,
    components
  }), /* @__PURE__ */ React3.createElement(Path, {
    d: modules.map((m) => moduleToD(quietZone + m.x * moduleSize, quietZone + m.y * moduleSize, moduleSize, modulePreset)).join(" ")
  })), logo && /* @__PURE__ */ React3.createElement(Logo, __spreadProps(__spreadValues({}, logo), {
    components,
    qrcodeSize: size,
    backgroundColor
  })));
};

// src/util/http-to-data-uri.ts
import fetch from "isomorphic-fetch";
var httpToDataURI = (url) => __async(void 0, null, function* () {
  const response = yield fetch(url);
  const mimeType = response.headers.get("content-type");
  const data = yield response.arrayBuffer();
  return `data:${mimeType};base64,${Buffer.from(data).toString("base64")}`;
});
export {
  EYE_DIMENSIONS,
  QRCode2 as QRCode,
  QRCodeModulePreset,
  createQRCode,
  httpToDataURI,
  isEye
};
//# sourceMappingURL=index.js.map
